export default __webpack_public_path__ + "static/media/package-d.ae07da01.jpg";